import { atom } from 'jotai';

/**
 * True while a page's closing section owns the end of the document.
 *
 * The next-listing turn commits when the reader settles at the scroll clamp,
 * so the section that turns must be the last thing the document can scroll
 * to — a footer below it is dead ground past the turn, and flying into it
 * strands the reader under a section that never fires. The section claims
 * this on mount and hands it back when it goes; a page whose closing section
 * stands down (no next listing) keeps its footer.
 */
export const footerSuppressedAtom = atom(false);
